export const adminS = {
  icon: 'fas fa-user-lock',
  text: 'crud_admins',
  link: 'gestion-admins',
}
